import { FieldPath } from '../../models/FieldPath.model';
import { FieldValidator } from '../../models/FieldValidator.model';
import { ValidationRules } from '../../models/ValidationRuleNames.model';
import { createRequiredValidator } from '../commons/required.validator';
import { createNonEmptyValidator } from '../list/nonEmpty.validator';

export function createCollateralSubFieldValidatorsMap(
    nullable: boolean,
    customMessages?: Record<ValidationRules, string>,
): Record<FieldPath, FieldValidator[]> {
    const customMsg = customMessages?.required;
    return {
        'uniqueIdentifier': [ createRequiredValidator(nullable, { fieldName: 'Unique Identifier', customMsg }) ],
        'description': [ createRequiredValidator(nullable, { fieldName: 'Description', customMsg }) ],
        'limitTypes.$self': [
            createRequiredValidator(nullable, { fieldName: 'Limit Types', customMsg }),
            createNonEmptyValidator({ fieldName: 'Limit Types' }),
        ],
        'limitTypes.$item.limitType': [ createRequiredValidator(nullable, { fieldName: 'Limit Type', customMsg }) ],
        'limitTypes.$item.coverageLimit': [ createRequiredValidator(nullable, { fieldName: 'Coverage Limit', customMsg }) ],
        'limitTypes.$item.valuation': [ createRequiredValidator(nullable, { fieldName: 'Valuation', customMsg }) ],
        'limitTypes.$item.deductible': [ createRequiredValidator(nullable, { fieldName: 'Deductible', customMsg }) ],
    } as Record<string, FieldValidator[]>;
}
